import { QuestionBase } from "src/app/core/components/dynamic-form/models/question-base";

export const searchConfigPhysical: QuestionBase[] = [
  {
    key: "firstName",
    label: "Nome",
    required: false,
    controlType: "textbox",
    placeholder: "Inserire Nome",
    size: "sm-4",
    type: "text",
  },
  {
    key: "lastName",
    label: "Cognome",
    required: false,
    controlType: "textbox",
    placeholder: "Inserire Cognome",
    size: "sm-4",
    type: "text",
  },
  {
    key: "email",
    label: "Email",
    placeholder: "selezione Email",
    size: "sm-4",
    required: false,
    controlType: "textbox",
    type: "email",
  },
  {
    key: "taxNumber",
    label: "Codice Fiscale",
    placeholder: "Inserisci Codice Fiscale",
    size: "sm-6",
    required: false,
    controlType: "textbox",
    type: "",
  },
  {
    key: "vatNumber",
    label: "Partita IVA",
    placeholder: "Inserisci Partita IVA",
    size: "sm-6",
    required: false,
    controlType: "textbox",
    type: "",
  },


];
